import { render, staticRenderFns } from "./ReiniciarLogin.vue?vue&type=template&id=552ff440"
import script from "./ReiniciarLogin.vue?vue&type=script&lang=ts"
export * from "./ReiniciarLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports